import React from "react";
import { connect } from "react-redux";
import { resetPassword } from "actions/user";
import { push } from "connected-react-router";
import PropTypes from "prop-types";

import CancelButton from "components/CancelButton";
import Card, { CardBlock } from "components/Card";
import SubmitButton from "components/SubmitButton";
import TitledText from "components/TitledText";
import { DataStorage, initializeMoment } from "utils";
import Translate from "utils/translate";
import { getUrlParams } from "utils/urlParams";

import styles from "./ResetPassword.css";

const { t } = new Translate("ResetPassword");

export class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    const resetParams = getUrlParams();
    this.state = { ...resetParams };
    this.handlePasswordReset = this.handlePasswordReset.bind(this);
    this.handleInput = this.handleInput.bind(this);

    initializeMoment(resetParams.locale);
    DataStorage.setUserLocale(resetParams.locale);
  }

  handlePasswordReset(evt) {
    if (evt) evt.preventDefault();
    this.props.onResetPassword(this.state);
  }

  handleInput(attr, val) {
    this.setState({ [attr]: val });
  }

  render() {
    return (
      <div className={styles.root}>
        <form onSubmit={this.handlePasswordReset}>
          <Card>
            <CardBlock>
              <h1 className={styles.title}>{t("title")}</h1>
            </CardBlock>
            <CardBlock>
              <TitledText
                isRequired={this.state.isSubmitted && !this.state.password}
                onInput={(val) => this.handleInput("password", val)}
                placeholder={t("new_placeholder")}
                text={this.state.password}
                title={t("new_label")}
                type="password"
                isEdit
                isLarge
              />
            </CardBlock>
            <CardBlock>
              <TitledText
                isRequired={this.state.isSubmitted && !this.state.password_confirmation}
                onInput={(val) => this.handleInput("password_confirmation", val)}
                placeholder={t("confirm_placeholder")}
                text={this.state.password_confirmation}
                title={t("confirm_label")}
                type="password"
                isEdit
                isLarge
              />
            </CardBlock>
            <CardBlock>
              <div className={styles.footer}>
                <div className={styles.right}>
                  <SubmitButton
                    isSubmitting={this.props.isResettingPassword}
                    onSubmit={this.handlePasswordReset}
                  />
                </div>
                <div className={styles.left}>
                  <CancelButton onClick={this.props.onCancel} />
                </div>
              </div>
            </CardBlock>
          </Card>
        </form>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  isResettingPassword: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isResettingPassword: state.isResettingPassword,
});

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => dispatch(push("/login")),
  onResetPassword: (params) => dispatch(resetPassword(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
